import { compose, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';

import {
  answeredListSelector,
  selectUpcomingListCounter,
  selectUpcomingList,
  selectUpcomingSending,
} from '../../../redux/surveys/selectors';
import { selectGenderTypes } from '../../../redux/data/selectors';
import getComplementary from '../utils/getComplementary';
import { canEditPatient } from '../../../redux/context/selectors';
import { paginatedActions as answeredSurveysPaginatedActions } from '../../../redux/surveys/answered';
import styles from '../index.styl';

const mapStateToProps = state => ({
  isSending: selectUpcomingSending(state),
  upcomingListCounter: selectUpcomingListCounter(state),
  upcomingList: selectUpcomingList(state),
  answeredList: answeredListSelector(state),
  genderList: selectGenderTypes(state),
  canEdit: canEditPatient(state),
});

const mapDispatchToProps = {
  loadNextAnsweredRequests: answeredSurveysPaginatedActions.loadNextRequests,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
  withProps(({ genderList, profile, intl: { formatMessage } }) => {
    return {
      userComplementary: getComplementary(profile, genderList, formatMessage),
      userName: get(profile, 'displayableName'),
      userAvatar: get(profile, 'avatar.thumbMin'),
      formatMessage,
    };
  }),
);



// WEBPACK FOOTER //
// ./src/components/Surveys/SurveysDrawer/enhance.js